import { NumberFormat } from '@billy/design-system'

const currencyFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

interface GetBankAccountTotalAmountParams {
  amount: number
  currency: string
  locale?: string
}

export const getBankAccountTotalAmount = ({ amount, currency, locale }: GetBankAccountTotalAmountParams): string => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    ...currencyFormatOptions,
  })

  const parts = formatter.formatToParts(amount)

  const currencyIndex = parts.findIndex((part) => part.type === 'currency')
  const integerIndex = parts.findIndex((part) => part.type === 'integer')
  const currencyPart = parts[currencyIndex]

  // Switch text currencies to follow the value
  if (currencyPart?.value === currency && currencyIndex < integerIndex) {
    return NumberFormat.getCurrencyNumber(amount, currency, locale, currencyFormatOptions)
  }

  return formatter.format(amount)
}
